import { postGenericDocuments } from '@zurich/api/document';
import { useApi, useTranslation } from '@zurich/common/hooks';
export const usePostGenericDocumentsApi = () => {
    const { t } = useTranslation();
    return useApi({
        request: postGenericDocuments,
        options: { errorText: t('document.errors.uploadDocument') },
    });
};
